import React from "react";
import { Collapse, Grid, Typography } from '@material-ui/core';

import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
    item: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 12,
        // maxWidth:1565,
        alignItems: 'center',
        // whiteSpace: "normal",
        wordBreak: "break-all",
        // wordWrap: "break-word",

    },
    Text: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    }
}));


export default function CollapseLog({ expand, item }) {
    const classes = useStyles();

    return (
        <Collapse in={expand}>
            <div className={classes.item} >
                <Grid >
                    <Typography style={{ padding: "20px" }} className={classes.Text}>{item}</Typography>
                </Grid>
            </div >
        </Collapse >
    )

}

